
import LightLogDivCom from "./ShareComponents/LightLogDivCom.vue";
import pan from "@/components/Charts/PanChartCom.vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import lineChart from "@/components/Charts/RLineChartCom.vue";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import box from "@/components/BoxCom.vue";
import Vue from "vue";
import { CtrlType, EchartInitModel } from "@/assets/js/Model/InnerModel";
export default Vue.extend({
  data() {
    return {
      display: true,
      currentPolicy: [] as any,
      sid: null as any,
      detail: {
        deviceTypeSid: "12",
      } as any,
      infos: [] as any,
      policyes: [] as any[],
    };
  },
  mounted() {
    this.sid = this.$route.query.sid;
    this.getDetail();
    this.getLightEnger();
    this.getPolicies();
  },
  components: { box, pan, LightLogDivCom, lineChart },
  methods: {
    initTotalPan() {
      const data3: any = {
        Data: [
          {
            value:
              this.detail.deviceTypeSid == "12"
                ? this.detail.energy
                : this.detail.workEnergyTotalB,
            name: "总能耗(kw/h)",
          },
        ],
        height: "70%",
        radius: "110%",
      };
      const chart3: any = this.$refs.totalPan;
      if (chart3) {
        chart3.setOption(data3);
      }
      const chart1: any = this.$refs.fangDianPan;
      const data1: any = {
        Data: [
          {
            value: this.detail.saveEnergyTotalA,
            name: "总节电量(kw/h)",
          },
        ],
        height: "70%",
        radius: "110%",
      };
      if (chart1) {
        chart1.setOption(data1);
      }
    },
    async getPolicies() {
      const ret: any = await HttpUtil.XCHttpPost(
        Urls.GetDeviceTimePolicy,
        { deviceSid: this.sid },
        true,
        false
      );
      this.policyes = ret;
      this.currentPolicy = [];
      this.policyes.forEach((x: any) => {
        this.currentPolicy.push(x.sid);
      });
    },
    async getLightEnger() {
      const ret: any = await HttpUtil.XCHttpPost(
        Urls.GetLightEnergy,
        this.sid,
        true,
        false
      );
      //engerChart
      const dchart: any = this.$refs.engerChart;
      let labels: any[] = [];
      let datas: any[] = [];
      ret.forEach((x: any) => {
        labels.push(x.day.substr(5, 5));
        datas.push(x.dayEnergy);
      });
      const data: EchartInitModel = {
        Labels: labels,
        Data: [
          {
            Name: "每日能耗分析",
            Data: datas,
            Arear: {
              opacity: 0.3,
            },
          },
        ],
        isXValue: false,
        isInBar: false,
        Style: 0,
        LegendConfig: {
          textStyle: {
            color: "#fff",
          },
          top: "10",
        },
      };
      dchart.setOption(data);
    },
    initLightPan() {
      const option = {
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },
        series: [
          {
            radius: "80%",
            center: ["50%", "50%"],
            splitLine: {
              length: 20,
              lineStyle: {
                color: "#ffffff",
                width: 5,
              },
            },
            title: {
              offsetCenter: [0, "20%"],
              fontSize: 25,
              color: "#ffffff",
            },
            axisLabel: {
              distance: 15,
              color: "#fff",
              fontSize: 10,
            },
            startAngle: 180,
            endAngle: 0,
            name: "Pressure",
            type: "gauge",
            progress: {
              show: true,
            },
            detail: {
              valueAnimation: true,
              formatter: "{value}%",
              color: "#fff",
              fontSize: 50,
              offsetCenter: [0, "60%"],
            },
            data: [
              {
                value: this.detail.light,
                name: "亮度",
                fontSize: 25,
              },
            ],
          },
        ],
      };
      const lightPan: any = this.$refs.lightPan;
      lightPan.setOptionByAll(option);
      option.series[0].data = [
        { value: this.detail.batterySOC, name: "电池容量", fontSize: 25 },
      ];
      const batterPan: any = this.$refs.batterPan;
      batterPan.setOptionByAll(option);
    },
    async freshPolicy() {
      const ids = [this.detail.ctrlAddr];
      await DeviceRequestBill.CtrLightBySignal(ids, CtrlType.日出日落时间查询, 0);
      window.setTimeout(async () => {
        await this.getPolicies();
      }, 2000);
    },
    async getDetail() {
      const ret: any = await DeviceRequestBill.GetLightCtrs(this.sid, 1, 1);
      this.detail = ret.data[0];
      this.display = this.detail.deviceTypeSid == "12";
      this.infos = [];
      console.log(this.detail);
      this.infos.push({ name: "设备名称", value: this.detail.deviceName });
      this.infos.push({ name: "设备序号", value: this.detail.ctrlAddr });
      this.infos.push({ name: "日出时间", value: this.detail.sunRiseTime });
      this.infos.push({ name: "日落时间", value: this.detail.sunDownTime });
      this.infos.push({
        name: "在线状态",
        value: this.detail.online == 1 ? "在线" : "离线",
      });
      this.infos.push({ name: "软件版本", value: this.detail.firmwareVersion });
      this.infos.push({ name: "硬件版本", value: this.detail.hardwareVersion });
      this.infos.push({ name: "本地时间", value: this.detail.deviceTime });
      this.infos.push({ name: "运行时长", value: this.detail.currentTime + "分钟" });
      this.infos.push({ name: "灯内温度", value: this.detail.deviceTemper + "℃" });
      this.infos.push({ name: "信号强度", value: this.detail.signal });
      this.infos.push({ name: "实时电压", value: this.detail.voltage + " v" });
      this.infos.push({ name: "实时电流", value: this.detail.current + " A" });
      this.infos.push({ name: "实时功率", value: this.detail.power + " w" });
      this.infos.push({ name: "电网频率", value: this.detail.frequency + " Hz" });
      this.infos.push({ name: "功率因素", value: this.detail.powerFactory + "" });
      this.infos.push({
        name: "累计能耗",
        value:
          this.detail.deviceTypeSid == "12"
            ? this.detail.energy
            : this.detail.workEnergyTotalB + " kw.h",
      });
      this.infos.push({ name: "ICCID", value: this.detail.iccid + "" });
      this.infos.push({ name: "所在路段", value: this.detail.groupName + "" });
      this.infos.push({ name: "策略更新时间", value: this.detail.policyUpdateTime + "" });
      this.initTotalPan();
      this.initLightPan();
      const log: any = this.$refs.lightlog;
      log.show(this.sid);
      log.more(0);
      window.setInterval(() => {
        const chart: any = this.$refs.totalPan;
        const chart2: any = this.$refs.lightPan;
        if (chart) {
          chart.resize();
          chart2.resize();
        }
      }, 1000);
    },
  },
});
